import { render, staticRenderFns } from "./RsaPaiRuoliListComponent.vue?vue&type=template&id=6fa65e9c"
import script from "./RsaPaiRuoliListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPaiRuoliListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports